import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 스크립트 템플릿 리스트를 조회한다.
   * @return {[type]} [description]
   * @author jda
   */
  getScriptTemplate() {
    return axios.get(`${baseUrl}/settings/netdevice/schedule/get-script-template.do`);
  },
  /**
   * 스케줄을 저장한다.
   * @param  {[type]} params [description]
   * @author jda
   */
  addNedeviceSchedule(params) {
    return axios.post(`${baseUrl}/settings/netdevice/schedule/add-netdevice-schedule.do`, params);
  },
  /**
   * 네트워크 스케줄을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getNetdeviceScheduleList(params) {
    return axios.post(`${baseUrl}/settings/netdevice/schedule/get-netdevice-schedule.do`, params);
  },
  /**
   * 네트워크 스케쥴 설정을 삭제한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  deleteNetdeviceSchedule(params) {
    return axios.post(`${baseUrl}/settings/netdevice/schedule/delete-netdevice-schedule.do`, params);
  },
  /**
   * 스케줄 설정을 변경한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  updateNetdeviceSchedule(params) {
    return axios.post(`${baseUrl}/settings/netdevice/schedule/update-netdevice-schedule.do`, params);
  },
  /**
   * 스케쥴을 실행한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  executeSchedule(params) {
    return axios.post(`${baseUrl}/settings/netdevice/schedule/execute-schedule.do`, params);
  },
  /**
   * scheduleId로 스케쥴 정보를 가져온다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getScheduleInfoById(params) {
    return axios.post(`${baseUrl}/settings/netdevice/schedule/get-schedule-info-by-id.do`, params);
  },
  /**
   * 스캔 아이디를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getScanId(params) {
    return axios.get(`${baseUrl}/settings/netdevice/schedule/get-scan-id.do`, { params });
  },
  /**
   * 수집 서버 리스트를 조회한다.
   * @return {[type]} [description]
   * @author jda
   */
  getAgentMgrList() {
    return axios.get(`${baseUrl}/settings/netdevice/schedule/get-agent-mgr-list.do`);
  },
  /**
   * 스케쥴 수행 이력을 조회한다.
   * @return {[type]} [description]
   * @author jda
   */
  getJobHistory(params) {
    return axios.post(`${baseUrl}/settings/netdevice/schedule/get-job-history.do`, params);
  },
  /**
   * 선택가능한 보안정책의 목록을 가져온다.
   * @author yelim
   */
  getNetdeviceViolationRules(params) {
    return axios.post(`${baseUrl}/settings/netdevice/schedule/get-netdevice-violation-rules.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/netdevice/schedule.js